import React, { useState } from 'react'
import Popper from '@mui/material/Popper'
import { useStyles } from './CustomPopper.style'
import { CustomPopperProps } from '../model'

const CustomPopper = (props: CustomPopperProps) => {
  const {
    anchorEl,
    children,
    width = 270,
    textAlign,
    disablePortal = true,
    zIndex = 100,
    size = 'md',
    placement = 'bottom-start',
  } = props
  const classes = useStyles({ size, width, textAlign, zIndex })
  const [arrowRef] = useState<HTMLElement | null>(null)

  const open = Boolean(anchorEl)

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement={placement}
      disablePortal={disablePortal}
      className={classes.root}
      modifiers={[
        {
          name: 'flip',
          enabled: true,
        },
        {
          name: 'preventOverflow',
          enabled: false,
        },
        {
          name: 'arrow',
          enabled: true,
          options: {
            element: arrowRef,
          },
        },
      ]}
    >
      <div className={`${classes.paper} paper`}>
        <div className={classes.arrow} id="popper-arrow" />
        <div className={classes.inner}>{children}</div>
      </div>
    </Popper>
  )
}

export default CustomPopper
